import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = heroSlides.length;

  const goTo = useCallback((index: number) => {
    setCurrent((index + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo(current + 1);
    }, 6000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="w-full max-w-3xl">
          <p className="text-sm md:text-base text-white/80 mb-3 tracking-wider">
            {heroSlides[current].subtitle}
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading leading-tight">
            {heroSlides[current].title}
          </h1>
          <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
            {heroSlides[current].description}
          </p>
          <Link
            to={heroSlides[current].ctaLink}
            className="inline-block px-8 py-3 text-sm md:text-base font-medium rounded-full bg-primary-500 text-white whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            {heroSlides[current].ctaText}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'bg-white w-8'
                : 'bg-white/40 hover:bg-white/70'
            }`}
            aria-label={`幻灯片 ${index + 1}`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo(current - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm text-white flex items-center justify-center hover:bg-white/20 transition-all duration-300 cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-line text-lg"></i>
      </button>
      <button
        onClick={() => goTo(current + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm text-white flex items-center justify-center hover:bg-white/20 transition-all duration-300 cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-line text-lg"></i>
      </button>
    </section>
  );
}